import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ErrorBoundary from "./components/ErrorBoundary";



ReactDOM.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
  document.getElementById('root')
);


serviceWorker.register();
